export type { PinInputProps } from './lib/pin-input'
export { PinInput } from './lib/pin-input'
